import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { AlertCards, Danger, Href } from "../../../../../Constant";
import { H6, LI } from "../../../../../AbstractElements";

export const AlertCard = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div className="btn-group">
      <Dropdown isOpen={open} toggle={toggle}>
        <DropdownToggle caret color="info" className="text-white">
          {AlertCards}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block p-3 dark-form">
          <LI>
            <H6 className="fs-6 fw-bold pb-2">{Danger}</H6>
            <DropdownItem className="dropdown-item p-0 helper-truncate" href={Href}>TIt's a danger path.</DropdownItem>
          </LI>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
